import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface UiState {
  readonly drawerOpen: boolean;
  readonly activeRailItem: string | null;
  setDrawerOpen(open: boolean): void;
  setActiveRailItem(featureId: string | null): void;
  toggleDrawer(): void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      drawerOpen: true,
      activeRailItem: null,
      setDrawerOpen: (drawerOpen) => set({ drawerOpen }),
      setActiveRailItem: (activeRailItem) => set({ activeRailItem }),
      toggleDrawer: () => set((state) => ({ drawerOpen: !state.drawerOpen })),
    }),
    {
      name: "nasam-ui",
      storage: createJSONStorage(() => localStorage),
      partialize: ({ drawerOpen }) => ({ drawerOpen }),
    },
  ),
);
